import { Field } from 'contensis-core-api';
import { Entry } from 'contensis-management-api';
import { ContentTypeFieldAssertions } from './ContentTypeFieldAssertions';

/**
 * A series of helper methods for extracting data from a particular field
 */
export class ContentTypeFieldHelper {
  static assert = ContentTypeFieldAssertions;

  static GetAllowedContentTypes = (field: Field): string[] => {
    if (field.dataFormat === 'canvas') {
      const allowedCanvasTypes = ((
        field?.validations as any
      )?.allowedTypes?.types
        .filter(({ type }: { type: string }) =>
          ['_inlineEntry', '_link'].includes(type)
        )
        .map(
          (linkType: any) =>
            (linkType?.linkContentTypes?.allowed || []) as string[]
        ) || []) as string[][];
      return allowedCanvasTypes.flat().filter((t) => !!t);
    } else if (field.dataFormat === 'contenttype')
      return (field.validations as any)?.allowedIds?.ids || [];
    else return field?.validations?.allowedContentTypes?.contentTypes || [];
  };

  static GetAllowedListValues = (field: Field): string[] => {
    return (
      // CHALKY-1811: Fix type issue with labeledValues
      (field?.validations?.allowedValues as any)?.labeledValues?.map(
        (lv: { value: string }) => lv.value
      ) || []
    );
  };

  static GetComposerFields = (composerField: Field): Field[] =>
    composerField?.validations?.allowedFieldTypes?.fields || [];

  static GetComponentId = (field: Field): string =>
    field?.dataFormat
      ?.toString()
      .substring(field.dataFormat.indexOf('.') + 1) || '';

  static GetDefaultEntry = (field: Field): Entry | undefined => {
    return Object.values(field?.default || {})?.[0];
  };
}
